import type { ComponentProps, PropsWithChildren } from 'react'
import { type FlexStyle, Keyboard, KeyboardAvoidingView, Platform, StyleSheet } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { mesaColorNames } from '../theme'

export function OnboardingWrapper({
  paddingHorizontal = 10,
  children,
  testID,
}: PropsWithChildren &
  Pick<ComponentProps<typeof SafeAreaView>, 'testID'> &
  Pick<FlexStyle, 'paddingHorizontal'>) {
  return (
    <SafeAreaView
      style={{
        backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
        flex: 1,
        overflowY: 'scroll',
      }}
      testID={testID}
      onStartShouldSetResponder={() => {
        Keyboard.dismiss()
        return false
      }}
    >
      <KeyboardAvoidingView
        // KeyboardAvoidingView has different behavior on iOS and Android
        // React Native recommends setting a different behavior value for each platform
        // Documentation: https://reactnative.dev/docs/keyboardavoidingview#behavior
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={[{ paddingHorizontal }, styles.keyboardAvoidingView]}
      >
        {children}
      </KeyboardAvoidingView>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  keyboardAvoidingView:
    Platform.OS === 'web'
      ? { marginVertical: 100, marginHorizontal: 'auto' }
      : { flex: 1, paddingVertical: 10 },
})
